import { VERIFY_TOKEN } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

interface VerifyTokenResponse {
  valid: boolean;
  error?: string;
}

const verifyTokenApi = async (): Promise<VerifyTokenResponse> => {
  try {
    const response = await makeAuthenticatedRequest(VERIFY_TOKEN, {
      method: 'GET'
    });
    const result = await response.json();
    if (!response.ok) {
      return {
        valid: false,
        error: result.error
      };
    }

    return {
      valid: true
    };
  } catch (error) {
    return {
      valid: false,
      error: 'Failed to verify token'
    };
  }
};

export { verifyTokenApi, type VerifyTokenResponse };
